// 案件紐付け 認証コード入力
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Annotation from '../../atoms/Annotation';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import Text from '../../molecules/Text';
import CenterButton from '../../atoms/CenterButton';
import { KWANKGM00050A02 } from '../../const/api_modules';

const ReceptionLink: React.FC = () => {
  // 入力値を格納する
  const [auth_code, setAuthCode] = useState('');
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);
  // エラーメッセージの格納用
  const [error_message, setErrorMessage] = useState('');
  // 認証情報
  const node = document.getElementById('reception-link');
  const token = node?.dataset.token;
  const reception_id = node?.dataset.reception_id;
  const guarantor_sub_no = node?.dataset.guarantor_sub_no;

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setAuthCode(event.target.value);
  }, []);

  const handleClick = async () => {
    try {
      // エラーメッセージの初期化
      setErrorMessage('');
      setIsLoading(true);

      // 入力情報を元に認証処理
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/mypage/login/authentication_link_proc`,
        {
          token: token,
          reception_id: reception_id,
          auth_code: auth_code,
          guarantor_sub_no: guarantor_sub_no,
        }
      );

      // 認証処理が正常終了したか判定
      if (response.data.result) {
        // 案件紐付け処理
        const api = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
          reception_id: reception_id,
          reception_cd: response.data.detail.reception_cd,
          module_name: KWANKGM00050A02,
          detail: [
            { id: 0, name: 'reception_sub_cd', value: response.data.detail.reception_sub_cd },
            { id: 0, name: 'email', value: response.data.detail.email },
            { id: 0, name: 'birthday', value: auth_code },
          ],
          is_json: true,
        });

        // 処理結果
        if (api.data.result) {
          // ログアウト後に「ログイン(マイページ)画面」に遷移
          const response_logout = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/logout_reception_link`);
          if (response_logout.data.result) {
            location.replace(
              `${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`
            );
          } else {
            alert(response_logout.data.message);
          }
        } else {
          // エラーの場合
          alert(api.data.message);
        }
      }
    } catch (error) {
      if (error.response.data.message.auth_code) {
        setErrorMessage(error.response.data.message.auth_code);
      } else {
        alert('システムエラーが発生しました');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Block
        label="認証コード入力"
        content={
          <div className="container-box">
            <Annotation text="認証コードをご入力下さい。" />
            <div className="mb-5">
              <Text
                id="authenticate_code"
                label="認証コード"
                value={auth_code}
                placeholder="例) 19801215"
                handleChange={handleChange}
                maxlength={8}
                disabled={false}
                help_msg="※半角数字8文字で入力して下さい\n※法人の場合は設立年月日を入力して下さい"
                message={error_message}
                heading="生年月日・設立年月日"
                right_padding={true}
              />
            </div>
            <CenterButton
              label="認証コードを送信する"
              btn_class="arrow-right"
              handleClick={handleClick}
            />
          </div>
        }
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('reception-link')) {
  ReactDOM.render(<ReceptionLink />, document.getElementById('reception-link'));
}
